/**
 * Slim bar shown when a signed-in member previews the public landing page.
 * Points them back to the dashboard without requiring logout.
 */

import { Link } from 'react-router-dom';

import './LoggedInPublicSiteBanner.css';

export function LoggedInPublicSiteBanner() {
  return (
    <div className="bhg-logged-in-public-site-banner" role="status">
      <p className="bhg-logged-in-public-site-banner__text">
        You are viewing the public website
      </p>
      <Link to="/dashboard" className="bhg-button bhg-button--primary bhg-button--sm">
        Back to Dashboard
      </Link>
    </div>
  );
}
